import cx from 'classnames';
import React, { useEffect, useMemo } from 'react';

import { sensElementView } from '@/utils/sensors';

import styles from './index.module.scss';

interface Props {
  posterUrl: string;
  isBottom: boolean;
  reloadType: string;
  style?: Record<string, any>;
  shareBtn1?: string;
  shareBtn2?: string;
  sensorInfo: Record<string, any>;
  onSensors: (type: number) => void;
}

const TrialDirectPosterButton = React.memo(
  ({
    posterUrl,
    isBottom,
    onSensors,
    reloadType,
    style = {},
    shareBtn1 = '',
    shareBtn2 = '',
    sensorInfo = {}
  }: Props) => {
    const newStyle = useMemo(() => {
      if (!style?.width) {
        return {};
      }

      const width = parseInt(style.width, 10);
      const height = parseInt('80', 10);
      const isTwo = width > 375;

      return {
        width: `${(isTwo ? width : width * 2) / 100}rem`,
        height: `${(isTwo ? height : height * 2) / 100}rem`
      };
    }, [style]);

    const shareBtns = [shareBtn1, shareBtn2].filter(Boolean);

    useEffect(() => {
      sensElementView({
        ...(sensorInfo || {}),
        c_element_name: '运营活动活动页_组件浏览',
        material_type: '按钮',
        material_name: '生成海报（体验+直购）按钮'
      });
      if (!isBottom) {
        return undefined;
      }

      const setBottomHeight = () => {
        const $btn = document.getElementById('j-cp-btn');
        const $mbottom = document.getElementById('j-mbottom');

        if ($btn && $mbottom) {
          $mbottom.style.height = `${$btn.clientHeight}px`;
        }
      };

      setBottomHeight();
      window.addEventListener('resize', setBottomHeight);

      return () => {
        window.removeEventListener('resize', setBottomHeight);
      };
    }, [isBottom, newStyle]);

    if (shareBtns.length !== 2) {
      return null;
    }

    const content = shareBtns.map((btnSrc, index) => {
      const href = `${posterUrl}&posterPage=${index}`;

      return (
        <a
          key={btnSrc}
          onClick={() => onSensors(index)}
          href={href}
          data-reloadtype={reloadType}
          className={styles.item}>
          <img src={btnSrc} alt='' />
        </a>
      );
    });

    const className = cx(styles.btn, {
      [styles.bottom]: isBottom
    });

    return (
      <div
        id={isBottom ? 'j-cp-btn' : undefined}
        style={newStyle}
        data-reloadtype={reloadType}
        className={className}>
        {content}
      </div>
    );
  }
);

export default TrialDirectPosterButton;
